import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosConfig';

const ShippingPolicy = () => {
  const [shipping, setShipping] = useState('');

  useEffect(() => {
    const fetchShipping = async () => {
      try {
        const response = await axiosInstance.get("master/getshipping");

        if (response.data && response.data.length > 0) {
          setShipping(response.data[0].name);
        }
      } catch (error) {
        console.error("Error fetching shipping policy:", error);
      }
    };

    fetchShipping();
  }, []);

  return (
    <section className="py-5" style={{ background: "#f5f7fa" }}>
      <div className="container">

        {/* HEADER */}
        <div className="text-center mb-4">
          <h2 className="fw-bold" style={{ color: "#222" }}>
            Shipping Policy
          </h2>
          <p className="text-muted">
            Learn more about our shipping guidelines, timelines & delivery process.
          </p>
        </div>

        {/* CARD */}
        <div className="card shadow-sm border-0 rounded-4">
          <div className="card-body p-4">

            {/* SCROLLABLE CONTENT */}
            <div
              className="overflow-auto"
              style={{
                maxHeight: "500px",
                paddingRight: "5px"
              }}
              dangerouslySetInnerHTML={{ __html: shipping }}
            />

          </div>
        </div>

      </div>
    </section>
  );
};

export default ShippingPolicy;
